<template>
  <owa-page
    :is-showing-bandana="false"
    :is-showing-sitewide-modal="false"
  >
    <template #header>
      <slot name="page-header">
        <owa-page-header-simple key="header" />
      </slot>
    </template>

    <template #content>
      <slot name="page-content">
        <main
          id="main-content"
          tabindex="-1"
          role="main"
          class="app-content padding-y-6xl"
          :style="{
            'background-image': `${contentBackground}`,
            '--fa-secondary-opacity': '1.0',
            '--fa-primary-color': 'var(--fa-navy)',
            '--fa-secondary-color': 'var(--white)'
          }"
        >
          <div class="container">
            <div :class="`line-length-${lineLength} margin-auto`">
              <slot name="card">
                <article
                  :class="`card roomy ${theme}`"
                  :style="componentStyle"
                >
                  <slot name="header">
                    <div class="header padding-y-4xl">
                      <owa-question-mark-block
                        v-if="decorativeIconName === 'faBlockQuestion'"
                        block-color="var(--fa-navy)"
                        block-hover-primary-color="var(--fa-navy)"
                        block-hover-secondary-color="var(--fa-dk-yellow)"
                        block-size="4x"
                      />

                      <font-awesome-icon
                        v-else
                        :icon="$v7[decorativeIconStyle][decorativeIconName]"
                        size="4x"
                      />
                    </div>
                  </slot>
                  <div :class="`section text-left ${isSectionCompact}`">
                    <slot name="title">
                      <h1
                        v-if="hasTitle"
                        class="h4 margin-bottom-md"
                      >
                        {{ title }}
                      </h1>
                    </slot>

                    <slot name="copy">
                      <p>{{ copy }}</p>
                    </slot>

                    <slot name="action" />
                  </div>
                  <slot name="footer" />
                </article>
              </slot>

              <slot name="tip" />
            </div>
            <slot name="extras" />
          </div>
        </main>
      </slot>
    </template>

    <template #footer>
      <owa-page-footer-simple />
    </template>
  </owa-page>
</template>

<script>
  export default {
    name: 'PageFocused',

    props: {
      contentBackground: {
        type: String,
        default: 'url(/images/icons-gray-bg.svg)'
      },
      copy: {
        type: String,
        default: null
      },
      customStyle: {
        type: Object,
        default: () => {}
      },
      decorativeIconStyle: {
        type: String,
        default: 'duotone'
      },
      decorativeIconName: {
        type: String,
        default: 'faTriangleExclamation'
      },
      hasCompactSection: {
        type: Boolean,
        default: false
      },
      lineLength: {
        type: String,
        default: 'sm'
      },
      title: {
        type: String,
        default: null
      },
      theme: {
        type: String,
        default: 'yellow'
      }
    },

    computed: {
      componentStyle() {
        return {
          ...this.customStyle
        }
      },
      hasTitle() {
        return this.title
      },
      hasCopy() {
        return this.copy
      },
      isSectionCompact() {
        let sectionSpacing = ''

        if (this.hasCompactSection) {
          sectionSpacing = 'padding-top-0'
        }

        return sectionSpacing
      }
    }
  }
</script>
